// extracted by mini-css-extract-plugin
export var avatarContainer = "_9k-0";
export var avatarTypingWave = "_9k-i";
export var gray = "_9k-f";
export var green = "_9k-c";
export var icon = "_9k-9";
export var image = "_9k-1";
export var lg = "_9k-6";
export var md = "_9k-5";
export var presenceDot = "_9k-b";
export var red = "_9k-d";
export var sm = "_9k-4";
export var status = "_9k-a";
export var typingDot = "_9k-h";
export var typingPill = "_9k-g";
export var xl = "_9k-7";
export var xs = "_9k-3";
export var xxl = "_9k-8";
export var xxs = "_9k-2";
export var yellow = "_9k-e";